import { IconsId } from "@silversea-ssc/design-system-icons";
import clsx from "clsx";
import React from "react";
import { Icon } from "../Icon/Icon";
import styles from "./PenaltiesInfographicStep.module.scss";

export type PenaltiesInfographicStepColor = "green" | "yellow03" | "red";

export type PenaltiesInfographicStepProps = {
  dayLabel?: string;
  color: PenaltiesInfographicStepColor;
  label: string | JSX.Element;
  compactOnMobile?: boolean;
};

const withStepColorClass = (
  color: PenaltiesInfographicStepColor,
  className?: string
): string => {
  return clsx(className, {
    [styles.colorRed]: color == "red",
    [styles.colorGreen]: color == "green",
    [styles.colorYellow]: color == "yellow03"
  });
};

const StepWithoutDays: React.FC<
  React.PropsWithChildren<PenaltiesInfographicStepProps>
> = ({ children, color, compactOnMobile, ...step }) => {
  return (
    <div className={withStepColorClass(color, styles.step)}>
      {children}
      <div className={styles.line}></div>
      <div
        className={clsx(styles.content, {
          [styles.contentMobileCompact]: compactOnMobile
        })}
      >
        <div className={styles.label}>{step.label}</div>
      </div>
    </div>
  );
};

export const PenaltiesInfographicStep: React.FC<
  React.PropsWithChildren<PenaltiesInfographicStepProps>
> = ({ dayLabel, ...step }) => {
  return (
    <React.Fragment>
      <StepWithoutDays {...step}>
        <div className={styles.day}>
          <React.Fragment>
            <div className={styles.dayLabel}>{dayLabel || ""}</div>
            {dayLabel && (
              <Icon
                name="bullet"
                size="2x"
                padding={false}
                className={styles.dayIcon}
              />
            )}
          </React.Fragment>
        </div>
      </StepWithoutDays>
    </React.Fragment>
  );
};

export interface PenaltiesInfographicIconStepProps {
  iconName: IconsId;
  label: string;
}

export const PenaltiesInfographicIconStep: React.FC<
  React.PropsWithChildren<PenaltiesInfographicIconStepProps>
> = ({ iconName, label }) => {
  return (
    <div className={styles.iconStep}>
      <div className={styles.iconStepLabel}>{label}</div>
      <Icon
        name={iconName}
        size="2x"
        padding={false}
        className={styles.iconStepIcon}
      />
    </div>
  );
};
